<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'relatorio-pro-pesquisa') {
            next({ name: 'relatorio-pro-pesquisa-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'relatorio-pro-pesquisa') {
            this.$router.push({ name: 'relatorio-pro-pesquisa-list' });
        }
    },
};
</script>
